import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMinimize: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMinimize"><Path d="M12 13V22H2V13H12Z" fill="currentColor"/><Path d="M22 3V16H14V14.5H20.5V4.5H4.5V11H3V3H22Z" fill="currentColor"/><Path d="M13 12V7.49999H14.5V9.43933L17 6.93933L18.0607 7.99999L15.5607 10.5H17.5V12H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMinimize;
